import React, { useState, useCallback, useContext, useEffect} from 'react'
import {useHistory} from 'react-router-dom';
import Header from './header'
import IconNav from './iconNav'
import Button from './button'
import Radio from './radio'
import Itinerary from './flightItinerary'
import './button.css'
import Subheader from './subheader';
import CalculatorContext from '../Context'
const flightOrNot =[
  {
    text: "I did not fly as part of my visit",
    value: false
  },
  {
    text: "Enter my flight details below",
    value: true
  }
]

function distance(lat1, lon1, lat2, lon2) {
  var p = 0.017453292519943295;    // Math.PI / 180
  var c = Math.cos;
  var a = 0.5 - c((lat2 - lat1) * p)/2 + 
          c(lat1 * p) * c(lat2 * p) * 
          (1 - c((lon2 - lon1) * p))/2;

  return 7917.5 * Math.asin(Math.sqrt(a)); // 2 * R; R = 3963 mi
}


function Flights() {
  const history = useHistory();
  //const [selected, setSelected] = useState(0)
  const context = useContext(CalculatorContext);
  const itineraries = context.flightItineraries;
  const setItineraries = context.setFlightItineraries;
  const selected =context.selectedFlight;
  const setSelected =context.setSelectedFlight;
  const {setAirMiles} = context;
  const calculate= useCallback( (newItineraries, recalculate=true)=>{
    
    if(!recalculate){
      return setAirMiles(0)
    }
    const airMiles = newItineraries.reduce((prev, it)=>{      
      if(it.fromValue && it.toValue && it.viaValue){
        return prev + (distance(it.fromValue.latitude,
          it.fromValue.longitude,
          it.viaValue.latitude,
          it.viaValue.longitude ) +
          distance(it.toValue.latitude,
            it.toValue.longitude,
            it.viaValue.latitude,
            it.viaValue.longitude ) 
          )
          * it.passengers * 
          (it.flightType===0? 2:1)  
      }else if(it.fromValue && it.toValue){
      return prev + distance(it.fromValue.latitude,
               it.fromValue.longitude,
               it.toValue.latitude,
               it.toValue.longitude ) * it.passengers * 
               (it.flightType===0? 2:1)
      }
      return prev     
    },0)    
    setAirMiles(airMiles);    
  }, [setAirMiles])

  const addNewItinerary = useCallback( () =>{
    const newItineraries = itineraries.slice()
    newItineraries.push({
      toValue: window.calculator_options.is_big_sky ? {"id":3799,"iata":"BZN","icao":"KBZN","name":"Gallatin Field","city":"Bozeman","country":"United States","latitude":45.77750015,"longitude":-111.1529999} : null,
      fromValue: null,
      passengers: 1,
      via:"",
      flightType:0
    })
    setItineraries(newItineraries)
    //calculate(newItineraries)
  }, [itineraries, setItineraries]);
  

  const deleteItinerary =useCallback((index)=>{    
    const newItineraries = itineraries.slice()
    newItineraries.splice(index,1)
    setItineraries(newItineraries)
    calculate(newItineraries)
  },[itineraries,calculate,setItineraries])

  const changeItinerary = useCallback((index,value, recalculate=true)=>{        
    console.log("Changing flights ", value)
    const newItineraries = itineraries.slice()
    newItineraries.splice(index,1,value)
    setItineraries(newItineraries)        
    setSelected(1)
    if(recalculate){
      calculate(newItineraries)
    }
  }, [itineraries, setItineraries, calculate]);  
  
  return (
    <div className="flights">
      <Subheader>
        Flights
      </Subheader>
      <Radio selected={selected} options={flightOrNot} onChange={(i)=>{setSelected(i); calculate(itineraries, i==1)}}/>
      {selected == 1 && itineraries.map((i, index)=>
        <Itinerary index={index} itinerary={i} onChange={changeItinerary} onDelete={deleteItinerary}/>
      )}
      {selected == 1 && (
      <div className="small-tip">
        Need to add additional flights?
      </div>
      )}
      {selected == 1 && (
      <div className="buttons">
        <Button className="initial-button primary another" onClick={addNewItinerary}>
          ADD ANOTHER ITINERARY
        </Button>
        
      </div>
      )}
      <div className="buttons ">        
        <Button showImage={false} className="primary initial-button" onClick={()=>history.push('/') }>
          BACK
        </Button>
        <Button className="primary initial-button" onClick={()=>history.push('/driving') }>
          NEXT
        </Button>
      </div>
    </div>
  )
}

export default Flights